import { PalettesProps, presetDarkPalettes, presetPalettes } from '@ant-design/colors';
import { alpha, createTheme } from '@mui/material/styles';
import { ThemeMode } from '~/types/config';

import Flamingo from './theme/flamingo';

const Palette = (mode: ThemeMode) => {
  const colors: PalettesProps = mode === ThemeMode.DARK ? presetDarkPalettes : presetPalettes;

  let greyPrimary = [
    '#ffffff',
    '#fafafa',
    '#f5f5f5',
    '#f0f0f0',
    '#d9d9d9',
    '#bfbfbf',
    '#8c8c8c',
    '#595959',
    '#262626',
    '#141414',
    '#000000',
  ];
  let greyAscent = ['#fafafa', '#bfbfbf', '#434343', '#1f1f1f'];
  let greyConstant = ['#fafafb', '#e6ebf1'];

  if (mode === ThemeMode.DARK) {
    greyPrimary = [
      '#000000',
      '#141414',
      '#1e1e1e',
      '#595959',
      '#8c8c8c',
      '#bfbfbf',
      '#d9d9d9',
      '#f0f0f0',
      '#f5f5f5',
      '#fafafa',
      '#ffffff',
    ];
    greyAscent = ['#fafafa', '#bfbfbf', '#434343', '#1f1f1f'];
    greyConstant = ['#121212', '#d3d8db'];
  }
  colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

  const paletteColor = Flamingo(colors, mode);

  return createTheme({
    palette: {
      mode,
      common: {
        black: '#000',
        white: '#fff',
      },
      ...paletteColor,
      text: {
        primary:
          mode === ThemeMode.DARK ? alpha(paletteColor.grey[900]!, 0.87) : paletteColor.grey[700],
        secondary:
          mode === ThemeMode.DARK ? alpha(paletteColor.grey[900]!, 0.45) : paletteColor.grey[500],
        disabled: mode === ThemeMode.DARK ? paletteColor.grey[300] : paletteColor.grey[400],
      },
      action: {
        disabled: paletteColor.grey[300],
      },
      form: {
        input: {
          border: mode === ThemeMode.DARK ? '#18253E' : paletteColor.grey[400],
          disabled: {
            border: mode === ThemeMode.DARK ? '#18253E' : paletteColor.grey[300],
          },
        },
      },
      divider: mode === ThemeMode.DARK ? '#18253E' : paletteColor.grey['A800'],
      background: {
        paper: mode === ThemeMode.DARK ? '#13161B' : paletteColor.grey[0],
        default: paletteColor.grey.A50,
        tertiary: mode === ThemeMode.DARK ? '#041720' : paletteColor.grey[0],
        cards: mode === ThemeMode.DARK ? alpha(paletteColor.grey[0]!, 0.4) : paletteColor.grey[0],
        elevation1: mode === ThemeMode.DARK ? '#1B1C1E' : '#ffffff',
        elevation2: mode === ThemeMode.DARK ? '#121212' : '#fafafa',
        elevation3: mode === ThemeMode.DARK ? '#1E1E1E' : '#f5f5f5',
        elevation4: mode === ThemeMode.DARK ? '#2A292F' : '#D5D6D0',
        elevation5: mode === ThemeMode.DARK ? '#f5f5f50f' : '#fafafa',
      },
      table: {
        background: mode === ThemeMode.DARK ? 'transparent' : paletteColor.grey[50]!,
      },
      navigation: {
        text: mode === ThemeMode.DARK ? '#767F8F' : paletteColor.grey[700]!,
        textSelected: mode === ThemeMode.DARK ? '#D1D4DA' : paletteColor.primary.main,
        background: mode === ThemeMode.DARK ? '#011E35' : paletteColor.primary.lighter!,
        accent: mode === ThemeMode.DARK ? '#C48743' : paletteColor.primary.main,
      },
      payoutTracker: {
        stepActive: {
          background: mode === ThemeMode.DARK ? '#011E35' : alpha(paletteColor.primary.main, 0.25),
          border:
            mode === ThemeMode.DARK
              ? 'rgba(255, 255, 255, 0.14)'
              : alpha(paletteColor.primary.main, 0.25),
        },
        stepDisabled: {
          background: mode === ThemeMode.DARK ? '#717680' : paletteColor.grey[100]!,
          border: mode === ThemeMode.DARK ? '#717680' : 'transparent',
          text: mode === ThemeMode.DARK ? paletteColor.grey[100]! : paletteColor.grey[500]!,
        },
      },
      tooltip: {
        text: (mode === ThemeMode.DARK ? paletteColor.grey[100] : paletteColor.grey[0])!,
      },
    },
  });
};

export default Palette;
